import React from 'react';
import { DisplayContent, getCMSObject } from 'sg-ui-components';

import Diamond from '../Vendor/HTMLJackpotMeter/counter/Diamond';

const ProgressiveJackpot = ({ jackpots = [] }) => {
    const debugId = (Math.random() + 1).toString(36).substring(7);

    //? For debug: console.log('🔥 ProgressiveJackpot sweep', debugId, sweepstake);

    // Validation: input need to have valid jackpot names
    if ((Array.isArray(jackpots) && jackpots.length > 0) === false) return null;

    // Validation: CMS need to have valid jackpot names in the config
    const jackpotConfirmationTable = getCMSObject('data.components.progressiveJackpots.jsonBlock') ?? [];
    if ((Array.isArray(jackpotConfirmationTable) && jackpotConfirmationTable.length > 0) === false) return null;

    // Validation: filtered jackpot table also needs to have elements
    const filteredJackpots = jackpots.filter((jackpot) => jackpotConfirmationTable.find((element) => element.name == jackpot));
    if ((Array.isArray(filteredJackpots) && filteredJackpots.length > 0) === false) return null;

    const jackpotsMapping = filteredJackpots.map((jackpot) => jackpotConfirmationTable.find((element) => element.name == jackpot));
    if ((Array.isArray(jackpotsMapping) && jackpotsMapping.length > 0) === false) return null;

    // Current logic: we need to find the first valid url as the current Vendor component does not support the old format
    const firstProgressiveJackpotURL = jackpotsMapping.find((item) => item.url)?.url;

    return (
        <div className='progressive-jackpot-element position-absolute'>
            <DisplayContent note='Display only when the URL is set' isVisible={firstProgressiveJackpotURL}>
                <Diamond debugId={debugId} url={firstProgressiveJackpotURL} />
            </DisplayContent>
        </div>
    );
};

export default ProgressiveJackpot;
